import SimpleBar from "simplebar-react";
import { Col, Nav, NavItem, NavLink, Row } from "reactstrap";
import React, { useEffect, useState } from "react";
import classnames from "classnames";
import FoodMenuTab from "../guest/tabContent/foodMenuTab";
import GuestInvites from "./tabContent/guestInvites";
import EventDetails from "./tabContent/eventDetails";
import {
  foodPreOrderEventData,
  foodPreOrderEventGuestData,
  foodPreOrderEventGuestSearch,
} from "../../../../../store/foodPreOederEvent/action";
import "./organiserer.styles.css";
import { useDispatch, useSelector } from "react-redux";
import { isEmpty } from "lodash";
import { useParams } from "react-router-dom";

const EventOrganiser = ({ eventUserData, branding }) => {
  const params = useParams();
  const dispatch = useDispatch();
  const helperGetFoodPreOrderEventGuestList = () => {
    dispatch(
      foodPreOrderEventGuestSearch(
        [
          {
            foodpreorderevent: {
              Id: eventUserData?.data?.FoodPreOrderEvent_Id,
            },
          },
        ],
        params?.token
      )
    );
    dispatch(
      foodPreOrderEventGuestData(
        { id: eventUserData?.data?.FoodPreOrderEventGuest_Id },
        params?.token
      )
    );
  };
  useEffect(() => {
    helperGetFoodPreOrderEventGuestList();
  }, []);

  const { foodPreOrderEventGuestSearchAPI } = useSelector((state) => ({
    foodPreOrderEventGuestSearchAPI:
      state.FoodPreOrderEventReducer.foodPreOrderEventGuestSearch
        ?.foodpreordereventguest_list,
  }));
  const { foodPreOrderEventGuestDataAPI, foodPreOrderEventGuestDataLoading } =
    useSelector((state) => ({
      foodPreOrderEventGuestDataAPI:
        state.FoodPreOrderEventReducer.foodPreOrderEventGuestData
          ?.foodpreordereventguest_data,
      foodPreOrderEventGuestDataLoading:
        state.FoodPreOrderEventReducer.foodPreOrderEventGuestDataLoading,
    }));

  const Tabs = [
    {
      id: "1",
      name: "Guest Invites",
    },
    {
      id: "2",
      name: "Food Menu",
    },
    {
      id: "3",
      name: "Event Details",
    },
  ];

  useEffect(() => {
    dispatch(
      foodPreOrderEventData(
        { id: eventUserData?.data?.FoodPreOrderEvent_Id },
        params?.token
      )
    );
  }, [eventUserData]);

  const { foodPreOrderEventDataAPI } = useSelector((state) => ({
    foodPreOrderEventDataAPI:
      state.FoodPreOrderEventReducer.foodPreOrderEventData,
  }));

  useEffect(() => {
    if (isEmpty(foodPreOrderEventDataAPI)) return;
    setEventDetails(foodPreOrderEventDataAPI?.foodpreorderevent_data);
  }, [foodPreOrderEventDataAPI]);

  const [eventDetails, setEventDetails] = React.useState([]);
  const [activeTab, setActiveTab] = React.useState("1");

  const [availableFoodMenu, setAvailableFoodMenu] = useState([]);
  useEffect(() => {
    if (isEmpty(foodPreOrderEventDataAPI)) return;
    setEventDetails(foodPreOrderEventDataAPI?.foodpreorderevent_data);
  }, [foodPreOrderEventDataAPI]);
  useEffect(() => {
    if (isEmpty(foodPreOrderEventGuestDataAPI)) return;
    setAvailableFoodMenu(foodPreOrderEventGuestDataAPI?.foodmenu_list);
  }, [foodPreOrderEventGuestDataAPI]);
  return (
    <div>
      <div className="text-center">
        <img
          src={branding?.LogoUrl}
          alt="logo"
          style={{
            maxHeight: "300px",
            maxWidth: "300px",
            paddingBottom: "30px",
          }}
        />
      </div>
      <div className={"text-center"}>
        <h2 style={{ fontFamily: branding?.PortalCssFontFamilyDivHeading }}>
          Welcome Event Organiser
        </h2>
      </div>
      <div>
        <div id="mail-filter-navlist">
          <Nav
            className="nav nav-tabs nav-tabs-custom nav-primary gap-1 text-center border-bottom-0"
            role="tablist"
          >
            {Tabs.map((item, index) => (
              <NavItem key={index}>
                <NavLink
                  className={classnames(
                    { active: activeTab === item.id },
                    "fw-semibold"
                  )}
                  onClick={() => {
                    setActiveTab(item.id);
                  }}
                  href={"#"}
                >
                  <span className="  d-sm-inline-block">{item.name}</span>
                </NavLink>
              </NavItem>
            ))}
          </Nav>
        </div>
      </div>
      <div>
        <hr />
      </div>
      <div>
        <div className={" settings-page-main-frame-guest-list"}>
          <div
            className="settings-page-left-side  add-right-side-border invited-guest-list"
            style={{ width: "350px" }}
          >
            <div className="p-0 ps-4 pe-4 d-flex flex-column h-100  ">
              <SimpleBar className="mx-n4 px-4  " data-simplebar>
                <div className="invited-guest-list mt-3 d-flex flex-row justify-content-between">
                  <h5
                    style={{
                      fontFamily: branding?.PortalCssFontFamilyDivHeading,
                    }}
                  >
                    Guest List
                  </h5>
                  <div>
                    <span title={"Confirmed / Accepted"}>
                      {
                        foodPreOrderEventGuestSearchAPI?.filter(
                          (item) =>
                            item?.FoodPreOrderEventGuestStatus_Id === "2" ||
                            item?.FoodPreOrderEventGuestStatus_Id === "4"
                        )?.length
                      }
                    </span>{" "}
                    /{" "}
                    <span title={"Invited Guests"}>
                      {" "}
                      {foodPreOrderEventGuestSearchAPI?.length}{" "}
                    </span>
                  </div>
                </div>
                <div className={"food-menu-items-selection  "}>
                  <div className={"pt-2"}>
                    <div>
                      {foodPreOrderEventGuestSearchAPI?.map((item, index) => (
                        <div
                          key={index}
                          className={
                            "d-flex justify-content-between align-items-center"
                          }
                        >
                          <span>{item?.FoodPreOrderEventGuest_FullName}</span>
                          <div
                            className={
                              "d-flex align-items-center justify-content-start"
                            }
                            style={{ width: "50px" }}
                          >
                            <span
                              className={
                                !item?.FoodPreOrderEventGuest_ContactEmailAddress
                                  ? "badge badge-soft-primary me-1"
                                  : item?.FoodPreOrderEventGuestStatus_Id ===
                                    "1"
                                  ? "badge badge-soft-warning me-1"
                                  : item?.FoodPreOrderEventGuestStatus_Id ===
                                    "2"
                                  ? "badge badge-soft-success me-1"
                                  : item?.FoodPreOrderEventGuestStatus_Id ===
                                    "3"
                                  ? "badge badge-soft-danger me-1"
                                  : "badge badge-soft-success me-1"
                              }
                              title={
                                item?.FoodPreOrderEventGuestStatus_FullName
                              }
                            >
                              <i className="fa-solid fa-envelope-circle-check  fs-8 "></i>
                            </span>
                            {item?.FoodPreOrderEventGuestStatus_Id !== "2" && (
                              <span
                                className={
                                  item?.FoodPreOrderEventGuestStatus_Id === "1"
                                    ? "badge badge-soft-dark me-1"
                                    : "badge badge-soft-success me-1"
                                }
                                title={
                                  item?.FoodPreOrderEventGuestStatus_Id === "4"
                                    ? "Food Selection Completed"
                                    : "Food Selection Not Completed"
                                }
                              >
                                <i className="fa-solid fa-utensils fs-8"></i>
                              </span>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                <div className="pb-4 border-bottom border-bottom-dashed"></div>
              </SimpleBar>
            </div>
          </div>
          <div className="settings-page-content-right-side">
            <SimpleBar className="   ">
              {activeTab === "1" && (
                <GuestInvites
                  eventUserData={eventUserData}
                  branding={branding}
                />
              )}
              {activeTab === "2" && (
                <FoodMenuTab
                  foodPreOrderEventDataAPI={foodPreOrderEventDataAPI}
                  availableFoodMenu={availableFoodMenu}
                  eventDetails={eventDetails}
                  eventUserData={eventUserData}
                  branding={branding}
                />
              )}
              {activeTab === "3" && (
                <EventDetails
                  eventUserData={eventUserData}
                  eventDetails={eventDetails}
                  branding={branding}
                  setActiveTab={setActiveTab}
                />
              )}
            </SimpleBar>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventOrganiser;
